import * as React from "react"
import { Head, router, usePage } from "@inertiajs/react"
import PublicLayout from "@/components/PublicLayout"
import { Button } from "@/components/ui/button"
import type { PageProps } from "@/types/inertia"

interface Props {
  booking: {
    starts_at: string
    london_label: string
    status: string
  }
  token: string
}

export default function GiselaBookCancel({ booking, token }: Props) {
  const { props } = usePage<PageProps>()
  const t = props.translations.consultation
  const [processing, setProcessing] = React.useState(false)

  function confirmCancel() {
    setProcessing(true)
    router.post(`/book/cancel/${token}`, {}, { onFinish: () => setProcessing(false) })
  }

  return (
    <>
      <Head title={t.cancel.meta_title}>
        <meta name="robots" content="noindex" />
        <meta name="description" content={t.cancel.heading} />
        <meta property="og:title" content={t.cancel.meta_title} />
        <meta property="og:description" content={t.cancel.heading} />
      </Head>
      <PublicLayout>
        <section className="bg-teal pt-32 pb-16 text-white">
          <div className="mx-auto max-w-2xl px-6 lg:px-8">
            <h1 className="text-white">{t.cancel.heading}</h1>
          </div>
        </section>

        <section className="bg-cream py-16">
          <div className="mx-auto max-w-2xl px-6 lg:px-8">
            <div className="rounded-2xl bg-white p-8 ring-1 ring-hairline">
              <p className="text-ink-body">
                {t.cancel.body.replace("%{time}", booking.london_label)}
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Button variant="danger" onClick={confirmCancel} disabled={processing}>
                  {t.cancel.confirm_button}
                </Button>
                <Button variant="secondary" asChild>
                  <a href="/book" className="no-underline">
                    {t.cancel.keep_button}
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </section>
      </PublicLayout>
    </>
  )
}
